import { makeStyles } from 'tss-react/mui';

const name = 'Page';

export const usePageStyles = makeStyles({ name })(theme => ({
  root: {
    flexGrow: 1,
    position: 'relative',

    width: '100%',
    padding: theme.spacing(5, 8),

    [theme.breakpoints.down('xl')]: {
      padding: theme.spacing(5, 5),
    },

    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(6, 7),
    },

    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(6, 9),
    },

    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(6, 4),
    },
  },
  withSuspendedUserAlert: {
    paddingTop: theme.spacing(2),

    [theme.breakpoints.down('xl')]: {
      paddingTop: theme.spacing(2),
    },

    [theme.breakpoints.down('md')]: {
      paddingTop: theme.spacing(7),
    },

    [theme.breakpoints.down('sm')]: {
      paddingTop: theme.spacing(4),
    },

    [theme.breakpoints.down('xs')]: {
      paddingTop: theme.spacing(4),
    },
  },
  content: {
    maxWidth: 1316,
    height: '100%',
    margin: '0 auto',
  },
  suspendedUserAlert: {},
}));
